/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React from 'react';
import IconButton from '@mui/material/IconButton';
import PropTypes from 'prop-types';
import MuiDialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import { Tooltip } from '@mui/material';
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import Typography from '@mui/material/Typography';
import './Dialog.style.scss';
import Constants from '../../../constants';

/**
 * Render Dialog DialogHeader.
 * onClose - Callback function to close the dialog
 */
const DialogHeader = props => {
  const {
    onClose,
    title,
    showBeta,
    toolTip,
    children,
    downloadPdf,
    icon,
    ...otherProps
  } = props;

  const { className } = otherProps;

  return (
    <MuiDialogTitle onClose={onClose} {...otherProps} className="dialog-header">
      <div className="dialog-header">
        {icon && <span className="dialog-header-icon">{icon}</span>}
        <Typography
          className={`dialog-heading ${className}`}
          title={toolTip}
          component="div"
        >
          {title}
          {showBeta && <sup>{Constants.BETA}</sup>}
        </Typography>
        {downloadPdf && (
          <Tooltip title={Constants.PRINTER_FRIENDLY_VERSION}>
            <IconButton
              data-testid="download-pdf-icon"
              aria-label="download-icon"
              className="download-icon"
              onClick={downloadPdf}
              size="large"
            >
              <PrintOutlinedIcon />
            </IconButton>
          </Tooltip>
        )}
      </div>
      <div className="btn-close">
        {children}
        <IconButton
          data-testid="btn-close"
          aria-label="dialog-close"
          onClick={onClose}
          size="large"
        >
          <CloseIcon />
        </IconButton>
      </div>
    </MuiDialogTitle>
  );
};

DialogHeader.propTypes = {
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  showBeta: PropTypes.bool,
  children: PropTypes.node.isRequired,
  toolTip: PropTypes.string,
  downloadPdf: PropTypes.func,
  icon: PropTypes.node
};

export default DialogHeader;
